import { render, staticRenderFns } from "./MessageCenter.vue?vue&type=template&id=2929dc6c&scoped=true"
import script from "./MessageCenter.vue?vue&type=script&lang=js"
export * from "./MessageCenter.vue?vue&type=script&lang=js"
import style0 from "./MessageCenter.vue?vue&type=style&index=0&id=2929dc6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2929dc6c",
  null
  
)

export default component.exports